
import {Directive, ElementRef, forwardRef, HostListener, Input} from '@angular/core';
import {MAT_INPUT_VALUE_ACCESSOR} from '@angular/material/input';
import {NG_VALUE_ACCESSOR} from '@angular/forms';

@Directive({
  selector: 'input[numberCeilingRounder]',
  providers: [
    {provide: MAT_INPUT_VALUE_ACCESSOR, useExisting: NumberCeilingRounderDirective},
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumberCeilingRounderDirective),
      multi: true,
    }
  ]
})

export class NumberCeilingRounderDirective {

  private _value: string | null;
  private newValue: number;
  hasSetvalidator = false;

  constructor(private elementRef: ElementRef<HTMLInputElement>
  ) {}


  get value(): string | null {
    return this._value;
  }

  @Input('value')
  set value(value: string | null) {
    this._value = value;
    this.formatValue(value);
  }

  private formatValue(value: string | null) {
    if (value !== null && value !== undefined) {
      this.elementRef.nativeElement.value = this.roundUpToWholeNumber(value);
    } else {
      this.elementRef.nativeElement.value = null;
    }
  }

  private unFormatValue() {
    const value = this.elementRef.nativeElement.value;
    this._value = value.replace(/[^\d.-]/g, '');
    if (value) {
      this.elementRef.nativeElement.value = this._value;
    } else {
      this.elementRef.nativeElement.value = null;
    }
  }

  private roundUpToWholeNumber(value: string) {
    this.newValue = parseFloat(value);
    this.newValue = Math.ceil(this.newValue);
    value = this.newValue.toString()

    if(isNaN(this.newValue)) {
      return null;
    }
    this._value = value;
    this._onChange(this._value);

    value ="$" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return value;
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value) {
    this._value = value.replace(/[^\d.-]/g, '');
    this._onChange(this._value); // here to notify Angular Validators
  }

  _onChange(value: any): void {
  }

  writeValue(value: any) {
    this._value = value;
    this.formatValue(this._value); // format Value
  }

  registerOnChange(fn: (value: any) => void) {
    this._onChange = fn;
  }

  registerOnTouched() {
  }

  @HostListener('blur')
  _onBlur() {
    this.formatValue(this._value); 
  }

  @HostListener('focus')
  onFocus() {
    this.unFormatValue(); // remove commas for editing purpose
  }
}
